<div class="dashboard--module-header">
    <h2 class="subheading-sm">Screen messages <button class="info-btn focus-element" (click)="onClickInfo()"><span class="focus--content" tabindex="-1"><span>i</span></span></button><span class="subheading--status" *ngIf="showProgress" [ngClass]="{'text-color__warning': (progress == 'In Progress'), 'text-color__success': (progress == 'Completed'), 'text-color__error': (progress == 'Error')}">{{progress}}</span></h2>
    <div class="btn-group">
        <button *ngIf="editMessageToggle" (click)="onSubmit(form)" class="focus-element"><span class="focus--content" tabindex="-1" title="Send screen message"><svg class="m-ic"><use xlink:href="#ic-send" href="#ic-send"></use></svg></span></button>
        <button *ngIf="editMessageToggle" (click)="toggleEditMessage()" class="focus-element"><span class="focus--content" tabindex="-1" title="Cancel editing"><svg class="m-ic"><use xlink:href="#ic-close" href="#ic-close"></use></svg></span></button>
        <button *ngIf="!editMessageToggle && !progress" (click)="toggleEditMessage()" class="focus-element"><span class="focus--content" tabindex="-1" title="Create screen message"><svg class="m-ic"><use xlink:href="#ic-add" href="#ic-add"></use></svg></span></button>
    </div>
</div>
<div class="dash-grid--item full-width module">
    <ng-container *ngIf="!editMessageToggle; else editMessage">
        <div class="block-num text-center" *ngIf="!screenMessages.length || screenMessages.length == 0">
            <span class="sm">no screen messages</span>
        </div>
        <div class="block-detail">
            <table class="std-table stacked-sm" *ngIf="screenMessages.length && screenMessages.length > 0">
                <thead>
                <th>Date sent</th>
                <th>Consumer name</th>
                <th>Message</th>
                </thead>
                <tbody>
                    <tr *ngFor="let message of screenMessages">
                        <td data-label="Date sent">{{message.messageDate | date:'dd/MM/yyyy' }}</td>
                        <td data-label="Consumer name">{{message.consumerName}}</td>
                        <td data-label="Message">{{message.message}}</td>
                    </tr>
                </tbody>
            </table>
            <app-pagination [page]="screenPage" [pages]="totalPages" (pageChange)="pageSelected($event)"></app-pagination>
            </div>
    </ng-container>
    <ng-template #editMessage>
            <form [formGroup]="form" (ngSubmit)="onSubmit()" class="module--main module--main__column" #messageEditForm>
                <div class="organise-select text-left">
                    <label>Select template:</label>
                    <select (change)="onChange($event.target.value)" class="select__standalone">
                        <option *ngFor="let templates of messageTemplates" [value]="templates.messageName">{{templates.messageName}}</option>
                    </select>
                </div>
                <div class="form-group form-group__large">
                    <label class="text-left" for="message">Message</label>
                    <div class="input-addon input-addon__std right">
                        <textarea name="" id="message" maxlength="120" cols="130" rows="10" class="input-addon__std--input" [value]="selectedTemplateMessage" [formControl]="form.controls['message']"></textarea>
                        <span class="input-addon__std--text-overlay">{{messageLength}}/120</span>
                    </div>
                </div>
            </form>
    </ng-template>
</div>
